
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"レイヤー_1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 417 658"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.38 577.58a9.509 9.509 0 0 0 9.2 4.5c.56-.06 57.37-6.36 134.16-.51 70.52 5.37 172.84 22.38 259.87 72.91 3.46 2 7.73 2.86 12.39 2.99V69.5h-2.56c-1.37 0-2.67-.57-3.62-1.56C373.47 29.26 296.85 6.86 182.68 1.3 91.91-3.11 9.35 5.22 8.53 5.31 3.68 5.81 0 9.89 0 14.76v557.62c0 1.82.42 3.64 1.38 5.2z","fill":"#727171"}}),_c('path',{attrs:{"d":"M145.76 562.59c-59.69-4.52-106.64-1.97-126.76-.37V23.44c23.18-1.95 90.43-6.69 162.98-3.15 108.3 5.29 182.43 26.46 215.68 61.39.87.92 1.34 2.15 1.34 3.41v542.9c0 .75-.79 1.23-1.46.88-35.96-18.9-76.49-34.13-120.75-45.39-40.82-10.37-84.9-17.4-131.03-20.89z","fill":"#fff"}})])
          )
        }
      }
    